import historyReducerCreator from './historyReducerCreator'

import {
  SAVE_KEG_ORDER_HISTORY,
  SAVE_SINGLE_KEG_ORDER_HISTORY_ITEM,
  DELETE_KEG_ORDER_HISTORY_ITEM,
} from '../../actions/actionTypes'


export default historyReducerCreator({
  saveHistoryOfSingleCustomerActionType: SAVE_KEG_ORDER_HISTORY,
  saveSingleHistoryItemActionType: SAVE_SINGLE_KEG_ORDER_HISTORY_ITEM,
  deleteSingleHistoryItemActionType: DELETE_KEG_ORDER_HISTORY_ITEM,
})
